import { render, staticRenderFns } from "./historyLive.vue?vue&type=template&id=1d657ec2&scoped=true&"
import script from "./historyLive.vue?vue&type=script&lang=js&"
export * from "./historyLive.vue?vue&type=script&lang=js&"
import style0 from "./historyLive.vue?vue&type=style&index=0&id=1d657ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d657ec2",
  null
  
)

export default component.exports